import axios from "axios";

const BASE_URL = '/web/rest-profile/employee';


export function getEmployeesAsList() {
    return axios.get(`${BASE_URL}/list`).then(response => response.data);
}

export function getEmployeeById(id) {
    return axios.get(`${BASE_URL}/${id}`).then(response => response.data);
}

export function registerEmployee(employeeDetails) {
    return axios.post(BASE_URL, employeeDetails).then(response => response.data);
}

export function mutateEmployee(employeeDetails) {
    return axios.post(`${BASE_URL}/${employeeDetails.id}`, employeeDetails).then(response => response.data);
}

export function deleteEmployee(employeeDetails) {
    return axios.delete(`${BASE_URL}/${employeeDetails.id}`).then(response => response.data);
}